import { jsx } from "react/jsx-runtime";
import { useToaster } from "react-hot-toast";
import styled from "styled-components";
import { token } from "./token.js";
import { Portal } from "./Portal.js";
import { NotificationPosition } from "./NotificationPosition.js";
import { zIndex } from "./zIndex.js";
function Notifications() {
  const {
    toasts,
    handlers
  } = useToaster();
  const {
    startPause,
    endPause,
    calculateOffset,
    updateHeight
  } = handlers;
  return /* @__PURE__ */ jsx(Portal, {
    children: /* @__PURE__ */ jsx(NotificationsStyled, {
      onMouseEnter: startPause,
      onMouseLeave: endPause,
      children: toasts.map((toast) => /* @__PURE__ */ jsx(NotificationPosition, {
        toast,
        calculateOffset,
        updateHeight
      }, toast.id))
    })
  });
}
const NotificationsStyled = styled.div.withConfig({
  displayName: "NotificationsStyled",
  componentId: "sc-3b8h0w-0"
})(["position:fixed;bottom:", ";left:", ";z-index:", ";"], token.spacing6, token.spacing6, zIndex);
export {
  Notifications
};
//# sourceMappingURL=Notifications.js.map
